import { IST_ZONE } from '@pams/shared';
import { DateTime } from 'luxon';

/**
 * ⚠️ [P7C §6a] "NOW", AS A LUXON VALUE IN IST — THE ONE DOOR IN `web/src` TO THE CURRENT TIME.
 *
 * `DateTime.now()` answers in the BROWSER's zone. The server decides every business date in IST
 * (`istDutyDate`, CLAUDE.md §7 [IST-FIX]), so a form seeded from the browser's "today" is dated
 * YESTERDAY for five and a half hours of every day on a machine set to UTC — and publish's
 * past-date blocker then refuses the order the builder itself filled in. That is the defect
 * `journeyRaise.spec.ts` hit every evening from 18:30 UTC, and it is a production defect for any
 * operator whose laptop is not set to Indian time.
 *
 * Seed a date from this, compare dates with `toISODate()` (a calendar-day string), and never
 * compare two instants to decide "is this day later". `browserDay.test.ts` holds the rule:
 * `DateTime.now(` and its siblings may appear in this file and nowhere else in `web/src`.
 */
export const istNow = (): DateTime => DateTime.now().setZone(IST_ZONE);
